import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';

/** Supplies cached installed or deployed release metadata without transport or account dependencies. */
@Injectable({ providedIn: 'root' })
export class AppInfoService {
  version?: string;
  build?: string;
  availability: 'pending' | 'available' | 'failed' = 'pending';
  readonly ready: Promise<void> = this.initialize();

  private async initialize(): Promise<void> {
    try {
      const info = Capacitor.isNativePlatform()
        ? await App.getInfo()
        : { version: environment.version, build: process.env['NG_APP_BUILD_NUMBER'] };
      this.version = info.version || undefined;
      this.build = info.build || undefined;
      this.availability = 'available';
    } catch {
      this.availability = 'failed';
    }
  }
}